const mainNav = document.querySelector('.navbar-nav');
const parentItems = mainNav.querySelectorAll('.parent');

parentItems.forEach((item) => {
  const levelUpButton = item.querySelector('.sub-nav [data-nav-level-up]');

  levelUpButton.addEventListener('click', (e) => {
    e.preventDefault();
    levelUpButton.parentNode.parentNode.parentNode.parentNode.classList.remove('sub-nav-open');
    levelUpButton.parentNode.parentNode.parentNode.classList.remove('open');
  });

  item.querySelector(':scope > .nav-link').addEventListener('click', (e) => {
    e.preventDefault();
    item.classList.toggle('open');
    item.parentNode.classList.toggle('sub-nav-open');
  });
});
